import { get, httpDelete, patch, post } from "@readai/common/api";
import type { ApiTag, CreateCustomTagBody } from "@readai/common/types";
import { PatchCustomTagBody } from "@readai/common/types";

/**
 * Fetches all user tags
 * @returns ApiTag[]
 * */
export const getUserTags = async (): Promise<ApiTag[]> => {
  return get("/tags", { withCreds: true });
};

/**
 * Creates a custom tag
 * @returns void (201 No Content)
 * */
export const createTag = async (body: CreateCustomTagBody): Promise<void> => {
  return post("/tags", body, { withCreds: true });
};

/**
 * Updates a custom tag
 * @returns ApiTag
 * */
export const updateTag = async ({
  id,
  ...body
}: PatchCustomTagBody): Promise<ApiTag> => {
  return patch(`/tags/${id}`, body, { withCreds: true });
};

/**
 * Deletes a custom tag
 * @returns void (204 No Content)
 * */
export const deleteTag = async (id: ApiTag["id"]): Promise<void> => {
  return httpDelete(`/tags/${id}`, { withCreds: true });
};
